import { render, staticRenderFns } from "./PriceDetail.vue?vue&type=template&id=5b92e17c&scoped=true"
import script from "./PriceDetail.vue?vue&type=script&lang=js"
export * from "./PriceDetail.vue?vue&type=script&lang=js"
import style0 from "./PriceDetail.vue?vue&type=style&index=0&id=5b92e17c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b92e17c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b92e17c')) {
      api.createRecord('5b92e17c', component.options)
    } else {
      api.reload('5b92e17c', component.options)
    }
    module.hot.accept("./PriceDetail.vue?vue&type=template&id=5b92e17c&scoped=true", function () {
      api.rerender('5b92e17c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/leftMoudle/children/PriceDetail.vue"
export default component.exports